import React from 'react';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import s from './AiSparkleIcon.css';
export const AiSparkleIcon = () => /*#__PURE__*/React.createElement(SparklesFilledSmall, {
  className: s.icon,
  "aria-hidden": true
});
//# sourceMappingURL=AiSparkleIcon.js.map